<template>
    <div>
        <v-alert :value="!supplierTemplate" type="error" class="templateAlert">
            {{ this.$t('message.noTemplate') }}
        </v-alert>
        <div class="view-title" >
            <img class="icon-load" src='../assets/backup-24px.svg'  >
            <p class="title-load">{{ this.$t('message.newUploadTitle') }}</p>
            <br/>
            <br/>
            <p class="title-sugestion">{{ this.$t('message.newUploadHelperText1') }}</p>
        </div>
        <div class="search-bar">
            <v-container fluid class="pa-0">
                <v-layout row wrap>
                    <v-flex xs12 sm12 md12 class="pr-3">
                        <v-textarea
                            :disabled="!supplierTemplate"
                            class="lance"
                            readonly
                            auto-grow
                            rows="1"
                            v-model="path"
                            append-icon="more_horiz"
                            @click:append="requestFile()"
                            v-bind:label="$t('message.formPath')">
                        </v-textarea>
                        <input
                            type="file"
                            style="display: none"
                            ref="imageSelector"
                            accept=".xml,.pdf,image/*,.xlsx,.xls,.csv"
                            :multiple="true"
                            @change="onFilePicked($event)">
                    </v-flex>
                    <v-flex xs12 sm2 md2>
                        <v-btn
                            solo
                            color="primary"
                            :disabled="!filesToAdd.length > 0"
                            @click="addFiletoList()">
                            <span class="button-content">
                                {{ this.$t('message.newUploadAddButtonText') }}
                            </span>
                            <v-icon class="appended-element" aria-hidden="true" size="23px" dark>add</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
        
        {{ this.$t('message.newUploadHelperText2') }}
        <v-data-table
            :headers="headers"
            :items="list"
            :loading="loading"
            id="fileList"
            class="table-list elevation-5">
            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props">
                <tr v-bind:class="{ itemToDelete: props.item.file.name == itemToDelete }">
                    <td class="text-xs-left">{{ props.item.file.name }}</td>
                    <td class="text-xs-left">{{ (props.item.file.size / 1024).toFixed(2) + " KB" }}</td>
                    <td class="text-xs-center">
                        <v-btn fab small color="error" 
                            @click.stop="confirmDelete(props.item.file.name)"
                            :disabled="loading">
                            <img src="@/assets/icon-eliminar.svg" alt="">
                        </v-btn>
                    </td>
                </tr>
            </template>
            <template slot="no-data">
                {{ this.$t('message.dataTableNoFiles') }}
            </template>
        </v-data-table>
        <v-dialog v-model="deleteDialog" max-width="350">
            <v-card>
                <v-card-title class="headline">{{ this.$t('message.newUploadConfirmationTitle') }}</v-card-title>
                <v-card-text>{{ this.$t('message.newUploadConfirmationText') }}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" flat @click="deleteDialog=false; itemToDelete = '';">{{ this.$t('message.datetimePickerCancel') }}</v-btn>
                    <v-btn color="primary" flat @click="deleteDialog=false; removeFileFromList(itemToDelete)">{{ this.$t('message.datetimePickerAccept') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div class="search-bar">
            <v-container fluid class="pa-0">
                <v-layout row wrap>
                    <v-flex xs12 sm2 md2 class="pt-4">
                        <v-btn
                            solo
                            color="primary"
                            :disabled="!list.length > 0 || loading"
                            @click="prepFilesForUpload(uploadFiles)">
                            <span class="button-content">
                                {{ this.$t('message.newUploadUploadButtonText') }}
                            </span>
                            <v-icon class="appended-element" aria-hidden="true" size="23px" dark>cloud_upload</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
    </div>
</template>

<style scoped>
    .appended-element {
        padding-left: 5px !important;
    }
    .icon-load{
        width: 24px; 
        height: 24px; 
        vertical-align: text-bottom;
        margin-right: 10px;
    }

    .button-content {
        white-space: normal;
    }

    .drag {
        border: 3px dashed var(--v-primary-base);
    }

    .table-list {
        margin-top: 20px;
    }

    .view-title {
        margin-bottom: 20px;
    }
    .title-load{
        font-size: 21px;
        font-weight: bold;
        display: inline;
    }
    .title-sugestion{
        font-size: 15px;
    }
    .templateAlert {
        border-radius: 50px;
        margin-bottom: 15px;
    }
</style>

<script>
    import { events, printList } from '../main';
    import _ from 'underscore';
    import moment from 'moment-timezone';
    var dragDrop = require('drag-drop');

    export default {
        data () {
            return {
                list: [],
                path: null,
                filesToAdd: [],
                loading: false,
                deleteDialog: false,
                itemToDelete: '',
                headers: [],
                currentSupplierCode: localStorage.getItem('supplierCode'),
                currentSupplierRFC: localStorage.getItem('supplierRFC'),
                credentials: JSON.parse(localStorage.getItem('supplierCredentials')),
                supplierTemplate: localStorage.getItem('supplierTemplate') == "true"
            }
        },
        methods: {
            isRfc(str) {
                let rfcRegEx = /^[A-Za-z&]{3,4}[0-9]{6}[A-Za-z0-9&]{3}$/;
                return rfcRegEx.test(str);
            },
            isExcel(file) {
                if (file.type && file.type != "") {
                    return file.type.indexOf("excel")!=-1 || 
                        file.type.indexOf("csv")!=-1 || 
                        file.type.indexOf("spreadsheet")!=-1;
                } else if (file.name) {
                    let extension = file.name.substring(file.name.lastIndexOf("."));
                    return extension.toLowerCase() == ".xls";
                } else {
                    return false;
                }
            },
            snackbar: function(message) {
                events.$emit('snackbar', message);            
            },
            goTo(url) {
                var self = this;
                self.$router.push('/' + url);
            },
            updateHeadersLanguage() {
                this.headers = [
                    { text: this.$t('message.newUploadHeaderFile'), value: 'file.name' },
                    { text: this.$t('message.newUploadHeaderSize'), value: 'file.size' },
                    { text: '', value: 'delete', align: 'center', sortable: false },
                ];
            },
            confirmDelete: function(name) {
                this.itemToDelete = name;
                this.deleteDialog = true;
            },
            setupDragAndDrop: function() {
                dragDrop('#fileList', (files, pos, fileList, directories) => {
                    let isNational = this.isRfc(this.currentSupplierRFC);
                    files.forEach(file => {
                        if (!this.list.some(e => e.file.name === file.name)) {
                            var type = file.type.split("/");
                            if (type[0] == "image" || type[1] == "pdf" || type[1] == "xml" || this.isExcel(file)) {
                                if (!isNational && type[1] == "xml") {
                                    this.snackbar(this.$t('message.newUploadInternationalRestrictionsText'));
                                } else {
                                    this.list.push({
                                        file: file,
                                    });
                                }
                            } else {
                                this.snackbar(this.$t('message.newUploadFileRestrictionsText'));
                            }
                        } else {
                            this.snackbar(this.$t('message.newUploadHelperText3') + file.name + this.$t('message.newUploadAlreadyAdded'));
                        }
                    });
                });
            },
            requestFile: function() {
                if (!this.loading) {
                    this.$refs.imageSelector.click();
                }
            },
            onFilePicked(e) {
                var files = e.target.files;
                var fileNames = [];
                let isNational = this.isRfc(this.currentSupplierRFC);
                if (this.path !== null && this.path !== "") {
                    fileNames = this.path.split(", ");
                }
                if (files.length > 0) {
                    Array.from(files).forEach(file => {
                        if (!fileNames.includes(file.name)) {
                            var type = file.type.split("/");
                            if (type[0] == "image" || type[1] == "pdf" || type[1] == "xml" || this.isExcel(file)) {
                                if (!isNational && type[1] == "xml") {
                                    this.snackbar(this.$t('message.newUploadInternationalRestrictionsText'));
                                } else {
                                    if (this.path === null || this.path === "") {
                                        this.path = file.name;
                                    } else {
                                        this.path += ", " + file.name;
                                    }
                                    fileNames.push(file.name);
                                    this.filesToAdd.push(file);
                                }
                            } else {
                                this.snackbar(this.$t('message.newUploadFileRestrictionsText'));
                            }
                        } else {
                            this.snackbar(this.$t('message.newUploadHelperText3') + file.name + this.$t('message.newUploadAlreadySelected'));
                        }
                    });
                }
            },
            addFiletoList() {
                if (this.filesToAdd.length > 0) {
                    let isNational = this.isRfc(this.currentSupplierRFC);
                    this.filesToAdd.forEach(file => {
                        if (!this.list.some(e => e.file.name === file.name)) {
                            var type = file.type.split("/");
                            if (type[0] == "image" || type[1] == "pdf" || type[1] == "xml" || this.isExcel(file)) {
                                if (!isNational && type[1] == "xml") {
                                    this.snackbar(this.$t('message.newUploadInternationalRestrictionsText'));
                                } else {
                                    this.list.push({
                                        file: file,
                                    });
                                }
                            } else {
                                this.snackbar(this.$t('message.newUploadFileRestrictionsText'));
                            }
                        } else {
                            this.snackbar(this.$t('message.newUploadHelperText3') + file.name + this.$t('message.newUploadAlreadyAdded'));
                        }
                    });
                } else {
                    this.snackbar(this.$t('message.newUploadNeedsFileToAdd'));
                }
                this.path = null;
                this.filesToAdd = [];
            },
            prepFilesForUpload(callback) {
                if (this.list.length > 0) {
                    this.loading = true;
                    let fileCount = this.list.length;
                    let fileList = [];
                    let fileTypeList = [];
                    let fileNameList = [];

                    for (let i = 0; i < this.list.length; i++) {
                        let entry = this.list[i];
                        getBufferFromFile(entry.file);
                    };

                    function getBufferFromFile(file) {
                        let fr = new FileReader();
                        fr.onload = function(event) {
                            let buffer = this.result;
                            fileList.push(buffer.split(",")[1]);
                            fileTypeList.push(file.type);
                            fileNameList.push(file.name);
                            if (!--fileCount) {
                                callback(fileList, fileTypeList, fileNameList);
                            }
                        };
                        fr.readAsDataURL(file);
                    }
                } else {
                    this.snackbar(this.$t('message.newUploadNeedsFileToUpload'));
                }
            },
            uploadFiles: function (fileList, fileTypeList, fileNameList) {
                const isNational = this.isRfc(this.currentSupplierRFC);
                
                if (isNational) {
                    const somePdfFile = fileTypeList.some(type => type === 'application/pdf');
                    const someXmlFile = fileTypeList.some(type => type === 'text/xml');
                    const pdfFileIndex = fileTypeList.findIndex(type => type === 'application/pdf');
                    const isValidPdfName = (pdfFileIndex > -1)
                        ? fileNameList.some((name, index) => this.removeExtension(name) === this.removeExtension(fileNameList[pdfFileIndex]) && index !== pdfFileIndex)
                        : false;
                    
                    if (!(somePdfFile && someXmlFile)) {
                        this.snackbar(this.$t('message.newUploadNationalSupplierFilesError'));
                        this.loading = false;
                        return;
                    }
                    if (!isValidPdfName) {
                        this.snackbar(this.$t('message.newUploadFileNameError'));
                        this.loading = false;
                        return;
                    }
                }


                var data = {};
                data.supplierCode = this.currentSupplierCode;
                data.fileList = fileList;
                data.fileTypeList = fileTypeList;
                data.fileNameList = fileNameList;
                data.typeLoad     = 'byUser';

                this.$http.post('SupplierFiles/', data).then(response => {
                    this.loading = false;
                    if (response.body.errors) {
                        this.snackbar(this.$t('message.newUploadError'));                        
                    } else {
                        this.list = [];
                        this.snackbar(this.$t('message.newUploadSuccess'));
                    }
                }, error => {
                    this.loading = false;
                    this.snackbar(error.message || error.status === 413 ? this.$t('message.newUploadSizeOverflow') : this.$t('message.newUploadError'));                            
                    console.error(error);
                });
            },
            removeFileFromList(deleteName) {
                this.list = this.list.filter(e => e.file.name !== deleteName);
                this.itemToDelete = '';
                this.snackbar(this.$t('message.newUploadRemoveFile'));
            },
            removeExtension(str) {
                return (str)
                    ? str.toString().split('.').slice(0, -1).join('.')
                    : str;
            }
        },
        mounted() {
            if(this.supplierTemplate){
                this.setupDragAndDrop();
            }
            this.updateHeadersLanguage();

            events.$on('updateLanguage', () => {
                this.updateHeadersLanguage();
            });
        },
        filters: {
            moment: function (date) {
                return moment(date).locale("es").format('LL');
            }
        }
    }
</script>